import merge from "../functions/merge";

const email = async (axios, id) => {
	await axios.post(`/invoices/${id}/email/`);
};

const post = async (axios, id) => {
	await axios.post(`/invoices/${id}/post/`);
};

export default {
	/*entity() {
		return merge({}, {
			_embedded: {
				
			},
			department_id: null,
			reservation_type_id: null,
			start_date: (new Date()).format('Y-m-d'),
			end_date: (new Date()).format('Y-m-d'),
			start_time: '00:00',
			end_time: '00:00',
			note: '',
			employees: [],
			vehicles: [],
			status: 'approved',
			frame: 'single'
		});
	},*/
	async save(axios, entity, doEmail, doPost) {
		var r;

		if (entity.id) {
			r = (await axios.put('/invoices/' + entity.id + '/', entity)).data;
		} else {
			r = (await axios.post('/invoices/', entity)).data;
		}

		if (doEmail) await email(axios, r.id);
		if (doPost) await post(axios, r.id);

		return r;
	},
	async read(axios, id) {
		return (await axios.get('/invoices/' + id + '/')).data;
	},
	async delete(axios, id) {
		return (await axios.delete('/invoices/' + id + '/')).data;
	},
	async email(axios, id) {
		await email(axios, id);
	},
	async post(axios, id) {
		await post(axios, id);
	}
};